module.exports = ""


//////////////////
// WEBPACK FOOTER
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/generic/loading/loading.component.html
// module id = ../../../../../src/app/generic/loading/loading.component.html
// module chunks = main